
import Calendar from '@/components/common/Date/Calendar.vue'
import hijriArLocal from '@/components/common/Date/Locale/hijri/ar'
import hijriEnLocal from '@/components/common/Date/Locale/hijri/en'
import gregorianArLocal from '@/components/common/Date/Locale/gregorian/ar'
import gregorianEnLocal from '@/components/common/Date/Locale/gregorian/en'
import HijriCalendarDate from '@/components/common/Date/Instance/HijriCalendarDate'
import CalendarDate from '@/components/common/Date/Instance/CalendarDate'

export default {
    name: 'DateFilterCalendar',
    components: { Calendar },
    props: {
        minDate: {
            type: String,
            required: true
        },
        maxDate: {
            type: String,
            required: true
        },
        calendar: {
            type: String,
            default: null
        },
        value: {
            type: null,
            default: null
        }
    },
    computed: {
        gregorianCalendarData () {
            return {
                class: CalendarDate,
                locale: this.$helpers.getLocale() === 'ar' ? gregorianArLocal : gregorianEnLocal
            }
        },
        hijriCalendarData () {
            return {
                class: HijriCalendarDate,
                locale: this.$helpers.getLocale() === 'ar' ? hijriArLocal : hijriEnLocal
            }
        },
        computedCalendar () {
            return this.calendar ?? Object.keys(this.dateData)[0]
        },
        calendarData () {
            return this[this.computedCalendar + 'CalendarData']
        },
        calendarDateData () {
            return this.dateData[this.computedCalendar]
        }
    }
}
